// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet documenten-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainDocumentSoort =
  (typeof SUREbusinessCommonDomainDocumentSoort)[keyof typeof SUREbusinessCommonDomainDocumentSoort];

export const SUREbusinessCommonDomainDocumentSoort = {
  APlazaBerichtDocument: 'APlazaBerichtDocument',
  CcsDocument: 'CcsDocument',
  CcsDocument1: 'CcsDocument1',
  InspectieFormulier: 'InspectieFormulier',
  Log: 'Log',
  Mail: 'Mail',
  Naverrekening: 'Naverrekening',
  Offerte: 'Offerte',
  PremieOverzichtPdf: 'PremieOverzichtPdf',
  PremieVragenOverzichtPdf: 'PremieVragenOverzichtPdf',
  ProductmaatschappijId: 'ProductmaatschappijId',
  RelatieNummer: 'RelatieNummer',
  Schade: 'Schade',
  SchadeFormulier: 'SchadeFormulier',
  TussenPersoon: 'TussenPersoon',
  TussenPersoonmemo: 'TussenPersoonmemo',
  Antwoord: 'Antwoord',
  Aanvraag: 'Aanvraag',
  MaatwerkVragenOverzichtPdf: 'MaatwerkVragenOverzichtPdf',
  InspectieAanvraagPdf: 'InspectieAanvraagPdf',
  Inspectierapport: 'Inspectierapport',
  AanvraagformulierInspectie: 'AanvraagformulierInspectie',
  InspectieGebruikerBestand: 'InspectieGebruikerBestand',
  Preventiemaatregelen: 'Preventiemaatregelen',
  PreventieMaatregelBijlage: 'PreventieMaatregelBijlage',
  OndertekendPreventiedocument: 'OndertekendPreventiedocument',
  MaatwerkDocument: 'MaatwerkDocument',
  Makelaarswijziging: 'Makelaarswijziging',
  HerinneringPreventiedocument: 'HerinneringPreventiedocument',
  VraagId: 'VraagId',
  KantoorDocument: 'KantoorDocument',
} as const;
